<template>
  <settings-modal
    class="free-text-notification-modal"
  >
    <template slot="heading">{{ heading }}</template>
    <div class="free-text-notification-modal-confirmation">
      <NotificationPreview
        v-for="(_, language) in notification"
        :key="language"
        :notification="notification[language]"
        :language="language"
      />
    </div>
    <hr>
    <div class="free-text-notification-receivers mt-2">
      Notification will be sent to these profiles:
      {{ profileIds.join(', ') }}
    </div>

    <error-alert :error="error" />

    <template slot="actions">
      <v-btn
        id="accept"
        color="primary"
        medium
        flat
        :disabled="loading"
        @click="onConfirmButtonClick"
      >confirm</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import SettingsModal from '@/components/modals/SettingsModal'
  import ErrorAlert from '@/components/ui/ErrorAlert'
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import NotificationsApi from '@/services/Api/NotificationsApi'
  import { mapActions, mapGetters } from 'vuex'
  import NotificationPreview from '@/components/notifications/notificationPreview'
  import { EVENT_FREETEXT_SENT } from '@/events/notifications'

  export default {
    name: 'FreetextAcceptNotificationModal',
    components: {
      NotificationPreview,
      SettingsModal,
      ErrorAlert
    },
    data () {
      return {
        sendFreetextNotificationApiRequest: new ApiRequest(NotificationsApi.sendFreetextNotification)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profileIds () {
        return this.modal.data.profileIds
      },
      notification () {
        return this.modal.data.notification
      },
      heading () {
        return `Are you sure you want to send notification?`
      },
      loading () {
        return this.sendFreetextNotificationApiRequest.loading
      },
      error () {
        return this.sendFreetextNotificationApiRequest.error
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      onConfirmButtonClick () {
        this.sendFreetextNotificationApiRequest
          .execute(this.modal.data)
          .then(this.sendFreetextNotificationSuccessHandler)
          .catch(() => {})
      },
      onCloseButtonClick () {
        this.closeModal()
      },
      sendFreetextNotificationSuccessHandler () {
        this.$eventHub.$emit(EVENT_FREETEXT_SENT)
        this.closeModal()

        setTimeout(() => {
          this.showModal({
            name: 'SuccessFlashModal',
            data: { message: 'Notification has been successfully sent.' }
          })
        }, 100)
      }
    }
  }
</script>
